import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography, Container } from "@mui/material";

function InventoryManagement() {
    const [inventory, setInventory] = useState([]);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/webApplication/inventory.txt",
        }).then((res) => {
            setInventory(res.data);
        });
    }, []);

    console.log("inventory", inventory)

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            <Box id="inventorymanagement" sx={{ mt: 8, mb: 6 }}>
                {/* Title */}
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem",  // mobile (~h4)
                            sm: "2.2rem",  // tablet (~h3)
                            md: "2.8rem",  // laptop (~h3+)
                            lg: "3rem",    // desktop (~h2)
                        },
                    }}
                >
                    Inventory Management
                </Typography>

                {/* Content */}
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", mt: 4 }}>
                    {inventory &&
                        inventory.map((data, index) => (
                            Array.isArray(data) ? (
                                <Box key={index} sx={{ mb: 3 }}>
                                    {/* Section Title */}
                                    <Typography
                                        variant="h5"
                                        sx={{ fontWeight: "bold", color: "#030366", mb: 1 }}
                                    >
                                        Salient Features
                                    </Typography>

                                    {/* List Items */}
                                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                                        {data.map((item, idx) => (
                                            <li key={idx}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{ fontFamily: "Raleway, sans-serif", textAlign: "justify", mb: 1 }}
                                                >
                                                    {item}
                                                </Typography>
                                            </li>
                                        ))}
                                    </ul>
                                </Box>
                            ) : (
                                <Typography
                                    key={index}
                                    variant="body1"
                                    sx={{ fontFamily: "Raleway, sans-serif", textAlign: "justify", mb: 2 }}
                                >
                                    {data}
                                </Typography>
                            )
                        ))}
                </Box>
            </Box>
        </Container>
    );
}

export default InventoryManagement;
